<template>
    <div class="finishing-position-pop-up">
        <table cellspacing="0" cellpadding="0">
            <tr v-on:click="onFinishPositionClicked(1)">
                <td><img :src="getImage('wf-finishing-position-1')" class="finishing-position-pop-up-icon"></td>
                <td><span>WINNING FORM HORSE</span></td>
            </tr>
            <tr v-on:click="onFinishPositionClicked(2)">
                <td><img :src="getImage('wf-finishing-position-2')" class="finishing-position-pop-up-icon"></td>
                <td><span>AFRICAN NIGHT SKY</span></td>
            </tr>
            <tr v-on:click="onFinishPositionClicked(3)">
                <td><img :src="getImage('wf-finishing-position-3')" class="finishing-position-pop-up-icon"></td>
                <td><span>MANTRACKER</span></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'FinishingPositionPopUp',
        components: {},
        props: {
            offsetLeft: Number,
            offsetTop: Number,
            onPositionClickedCallback: Function
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onFinishPositionClicked(position) {
                this.onPositionClickedCallback(position);
            }
        },
        mounted: function() {
            const popupWidth = document.querySelector('.finishing-position-pop-up').getBoundingClientRect().width;
            document.querySelector('.finishing-position-pop-up').style.left = `${this.offsetLeft - popupWidth - 15}px`;
            document.querySelector('.finishing-position-pop-up').style.top = `${this.offsetTop}px`;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .finishing-position-pop-up {
        position: absolute;
        z-index: 5;
        border-radius: 5px;
        border: solid 1px #000000;
        background-color: #FFFFFF;
        padding: 0.4rem;
    }

    .finishing-position-pop-up td {
        border: none;
        padding: 0.2rem;
        text-align: left;
    }

    .finishing-position-pop-up tr {
        cursor: pointer;
    }

    .finishing-position-pop-up-icon {
        width: 20px;
        height: 20px;
    }
</style>
